import { render, staticRenderFns } from "./info-list.vue?vue&type=template&id=535aa4fa&scoped=true&"
import script from "./info-list.vue?vue&type=script&setup=true&lang=ts&"
export * from "./info-list.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./info-list.vue?vue&type=style&index=0&id=535aa4fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535aa4fa",
  null
  
)

export default component.exports